__webpack_require__.p = "/dev/metadata-details/";